import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LandingPage } from "./components/LandingPage.jsx";
import { Projects } from "./components/Projects/Projects.jsx";

function App() {
    return (
        <div className="App">
            <Router>
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/projects" element={<Projects />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
